const mABCardArray = [
  {
    image: "benoit-headshot.jpg",
    name: "Benoit Ste-Marie",
    title: "BI Director",
    city: "Montréal, Québec, Canada ",
    description:
      "I am excited to join the MAB as I feel I could provide a relevant input to the next level that CEO wants to achieve and give reliable feedback on features/improvements. Personally I discovered the site in 2017 but really connected in 2020 and now it’s part of my daily ingestion related to market review. Ultimately I hope we can grow our community and generate a positive impact as a result of our actions.",
  },
  {
    image: "cody-headshot.jpeg",
    name: "Cody Evans",
    title: "Research Analyst",
    city: "Little Rock, Arkansas, USA ",
    description:
      "Networking and crowd sourced research is taken to the next level at CEO with the quality content and people it attracts. Along with expanding, I hope to see it retain users and continue to flourish as an enjoyable community. Connecting people for the sharing and discussion of ideas is gold.",
  },
  {
    image: "erik-headshot.jpeg",
    name: "Erik Groves",
    title: "Attorney & Investor",
    city: "Palmer, Alaska, USA",
    description:
      "Being successful as a retail investor is incredibly challenging with so much misinformation and questionable players - that is why the development of effective tools of information sharing on CEO.CA is so important to me.  It is a privilege to be able to serve on the MAB because I believe that even with all the progress that CEO.CA has made so far, there is tremendous potential to do much more.",
  },
  {
    image: "jack-headshot.jpg",
    name: "Jack Zeidan",
    title: "Financial Analyst",
    city: "Ottawa, Ontario, Canada ",
    description:
      "When I first joined CEO.ca in 2018, I didn't truly know the extent of how powerful of a product/community it is. Not only is it a wonderful platform, but I was able to make great connections and have insightful conversations with many other users. I am looking forward to providing my opinions and recommendations to enhance the overall user experience on CEO.ca.",
  },
  {
    image: "melissa-headshot.jpeg",
    name: "Melissa Mackie",
    title: "Investor Relations Manager",
    city: "Toronto, Ontario, Canada ",
    description:
      "CEO.ca is a powerful and valuable tool for knowledge sharing amongst the investment community, and with the shift to online communication vs in-person, platforms like CEO.ca are more relevant and important than ever. As an active user and IR professional, I look forward to contributing to its continued growth through new ideas that bring enhanced value to its users and make it the top platform for investor communication and resources.",
  },
  {
    image: "nick-headshot.jpg",
    name: "Nick Stefan",
    title: "Consultant",
    city: "Vancouver, British Columbia, Canada ",
    description:
      "A daily user of CEO.CA, I have gained so much valuable insight from my peers; I like the community and I want it to reach others. Storytelling is part of my job as a consultant, and the dialogue that is generated through the site complements the due diligence and tells a story that numbers alone, can’t. I get excited about the stocks, and I’m very excited to be a part of CEO.CA’s future.",
  },
  {
    image: "paul-headshot.jpeg",
    name: "Paul Ferguson",
    title: "Investor",
    city: "Boston, Massachusetts, USA",
    description:
      "CEO provides the ability to connect with other investors that are deeply experienced and knowledgeable, particularly in regard to natural resource-related investments.  I am excited about the platform that is being created by Goldspot with CEO.ca being an integral piece.  I am looking forward to the opportunity to work with other like-minded investors to help CEO.ca achieve its potential to be the best place for retail investors to discuss stocks on the Internet.",
  },
  {
    image: "marja-headshot.jpg",
    name: "Penny Stowell",
    title: "Penny Queen - Independent Analyst",
    city: "Seattle, Washington, USA",
    description:
      "I am proud to be representing the members of CEO in an effort to make this an even better community and place where we can all exchange information.  CEO is where a majority of my investment community and I get our day-to-day information on the companies we follow. As an investor, I am focused on transparency and decoupling small caps from pay for service promotion.",
  },
  {
    image: "peter-headshot.jpg",
    name: "Peter Bell",
    title: "Investor & CEO",
    city: "British Columbia, Canada",
    description:
      "I've been active on CEO.ca since it was first called chat.ceo.ca and it's been a big part of my life. All the interviews I've done of junior mining executives and live-tweet coverage of conferences has been a valuable way for me to practice my skills as an investor. Now that I'm a CEO of a public company, I want to help provide my perspective on why I've put so much time and effort into this community.",
  },
  {
    image: "robert-headshot.png",
    name: "Robert Park",
    title: "PhD Student",
    city: "London, Ontario, Canada ",
    description:
      "CEO.ca is a fantastic platform for investor discussion, stock discovery, and community experiences. I'm impressed and amazed by how well CEO.ca manages to keep its focus on investing while many online platforms these days appear to lose their original focus in the pursuit of growth. I look forward to understanding better and contributing to how CEO.ca can remain a fair and transparent platform for the betterment of all retail investors, just as it has improved my own investment choices.",
  },
  {
    image: "robert-sinn-headshot.jpg",
    name: "Robert Sinn",
    title: "Investor",
    city: "Fort Lauderdale, Florida, USA",
    description:
      "CEO.ca is an indispensable tool for investors interested in Canadian small caps. I have been on CEO.ca since its inception in early 2015 and I am grateful for the platform that it offers and all that I have learned from others. I believe that the MAB will help CEO.ca to more effectively navigate an ever changing investment landscape and help it to better adapt to the needs of its users.",
  },
  {
    image: "ronald-headshot.jpg",
    name: "Ronald Angsiy",
    title: "Investor & SVP, Intellabridge",
    city: "Palo Alto, California, USA ",
    description:
      "Ronald has always been active on message boards since he was 13, and now is active on multiple investing communities. The opportunity to be hands-on with one of the leading global stock communities presents an incredible opportunity and challenge for Ronald that he fully embraces. ",
  },
];

export default mABCardArray;
